module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_gentei-82d2b455e0610dfb8e74e69442f1bfb8.png";